function campaignBlock() {
  var $body = $('body');
  function initCampaignBlock(el) {
    var $el = $(el);
    var $min = $el.prev();
    $min.click(function () {
      $body.addClass('modal-open');
      $el.addClass('show in');
      $min.removeClass('in');
      $body.removeClass('c-min');
    });

    var $modalclose = $el.find('.modal-close');
    $modalclose.click(function () {
      $el.removeClass('in');
      setTimeout(function () { $el.removeClass('show'); $body.removeClass('modal-open'); }, 200);
      $min.addClass('in');
      $body.addClass('c-min');
    });

    var $modalcta = $el.find('.modal-cta');
    $modalcta.click(function () {
      $el.removeClass('in');
      setTimeout(function () { $el.removeClass('show'); }, 200);
      $min.addClass('in');
    });

    var $minclose = $min.find('.close');
    $minclose.click(function (e) {
      e.stopPropagation();
      $min.removeClass('in');
      setTimeout(function () { $min.addClass('hide'); }, 500);
      $body.removeClass('c-min');
      return false;
    });

    if ($el.hasClass('showonload')) {
      $body.addClass('modal-open');
      $body.removeClass('c-min');
      $el.addClass('show in');
    } else {
      $min.addClass('in');
      $body.addClass('c-min');
    }

  }

  return {
    initCampaignBlock: initCampaignBlock
  };
}
(function ($, document, window) {
  $(document).ready(function () {
    $('.campaign-block').each(function (idx, el) {
      var cb = new campaignBlock();
      cb.initCampaignBlock(el);
    });

    $('a[href*="showonload"]').each(function (idx, anchor) {
      var anchorHref = new URL(anchor.href)
      var locationHref = new URL(document.location.href)

      if (anchorHref.pathname == locationHref.pathname) {
        $(anchor).on('click', function (e) {
          e.preventDefault();
          var minimizedCampaign = $('.campaign-block-minimized');
          if (minimizedCampaign.length > 0 && minimizedCampaign.hasClass("in")) {
            minimizedCampaign.trigger('click');
          }

        })
      }

    });

  })
}(jQuery, document, window));